module.exports = __webpack_public_path__ + "img/leftLine.9357c155.svg";